import { Component, input, output } from '@angular/core';

/**
 * Case à cocher tactile pleine largeur, dimensionnée pour un usage au doigt.
 *
 * La case et son libellé forment **un seul bouton** : pas de `<label for>` à
 * rater ni de zone morte entre les deux, et une cible d'au moins 88 px de haut
 * sur toute la largeur — très au-delà des 44 px du WCAG 2.5.5, ce qui compte sur
 * un écran capacitif vertical où l'on vise sans précision.
 */
@Component({
  selector: 'app-touch-checkbox',
  standalone: true,
  templateUrl: './touch-checkbox.component.html',
  styleUrl: './touch-checkbox.component.scss',
})
export class TouchCheckboxComponent {
  readonly label = input.required<string>();
  readonly checked = input(false);

  readonly toggled = output<boolean>();

  onToggle(): void {
    this.toggled.emit(!this.checked());
  }
}
